/**
 * Created by aaron on 9/22/14.
 */
var ShapewaysModel = require('./ShapewaysModel');
var _ = require('underscore');
var sw = require('js/lib/sw');

var productViewActionTypes = require('js/lib/actions/ProductViewPage/actionTypes');
var ShapeJSRTActionTypes = require('js/lib/actions/ShapeJSRT/actionTypes');

var ERROR_LEVELS = {
  reject: 'REJECT'
};

var ShapeJsModel = ShapewaysModel.extend({

  pluralName: 'shapeJsParameters',

  actions: {
    shapeJsViewerIsAvailable: productViewActionTypes.SHAPE_JS_VIEWER_IS_AVAILABLE,
    shapeJsViewerActivate: productViewActionTypes.SHAPE_JS_VIEWER_ACTIVATE,
    shapeJsViewerIsActive: productViewActionTypes.SHAPE_JS_VIEWER_IS_ACTIVE,
    shapeJsMaterialSelected: ShapeJSRTActionTypes.SHAPE_JS_MATERIAL_SELECTED,
    shapeJsViewerStartPreventInteraction: productViewActionTypes.SHAPE_JS_VIEWER_START_PREVENT_INTERACTION,
    shapeJsViewerStopPreventInteraction: productViewActionTypes.SHAPE_JS_VIEWER_STOP_PREVENT_INTERACTION,
    shapeJsViewerUpdateParams: ShapeJSRTActionTypes.SHAPE_JS_UPDATE_PARAMS
  },

  defaults: {
    id: '',
    shapeJsViewer: {},
    script: '',
    parameters: {},
    printabilityChecks: [],
    currentConfiguration: '',
    configurations: {},
    isAvailable: false,
    isStarted: false,
    isActive: false,
    isPreventInteraction: false
  },

  parameterDefaults: {
    name: 'newParameter',
    desc: 'New Parameter',
    type: 'string',
    defaultValue: 'new param',
    onChange: ''
  },

  updateShapejsParameters: function updateShapejsParameters(parametersHash) {

    var paramHash = sw.utils.cloneDataObject(parametersHash);
    var parameters = this.get('parameters');
    var newParameters = sw.utils.cloneDataObject(parameters);

    _.each(paramHash, function (value, key) {
      newParameters[key] = value;
    }, this);

    this.set({
      parameters: newParameters,
      printabilityChecks: []
    });
  },

  resetParameters: function resetParameters() {
    this.updateShapejsParameters(this.initAttrs.parameters);
  },

  checkPrintabilityCached: function checkPrintabilityCached(callback) {
    var rtShapeJs = this.get('shapeJsViewer');

    rtShapeJs.checkScriptPrintabilityCached().done(_.bind(function (data) {
      this.set({
        printabilityChecks: data
      });

      if (callback) {
        callback(data);
      }
    }, this));
  },

  isPrintable: function isPrintable() {
    return _.reduce(this.get('printabilityChecks'), function (memo, checkItem) {
      if (checkItem.errorLevel === ERROR_LEVELS.reject) {
        return false;
      }

      return memo && true;
    }, true);
  },

  setConfiguration: function setConfiguration(configurationName) {
    var config = this.get('configurations')[configurationName];

    if (config) {
      this.updateShapejsParameters(sw.utils.cloneDataObject(config.shapeJsParameters));
      this.set({
        currentConfiguration: configurationName
      });
    }
  },

  getConfiguration: function getConfiguration(configurationName) {
    return sw.utils.cloneDataObject(this.get('configurations')[configurationName] || {});
  },

  /**
   * @param {object} currentAttrs Current state.
   * @param {object} action Action type and payload(isAvailable)
   * @return {object} Returns the changes in state
   */
  shapeJsViewerIsAvailable: function shapeJsViewerIsAvailable(currentAttrs, action) {
    return {
      isAvailable: action.payload.isAvailable
    };
  },

  /**
   * @param {object} currentAttrs Current state.
   * @param {object} action Action type and payload(shapeJsId)
   * @return {object} Returns the changes in state
   */
  shapeJsViewerActivate: function shapeJsViewerActivate(currentAttrs, action) {
    if (currentAttrs.isAvailable && currentAttrs.id === action.payload.shapeJsId && !currentAttrs.isStarted) {
      return {
        isStarted: true
      };
    }
  },

  /**
   * @param {object} currentAttrs Current state.
   * @param {object} action Action type and payload(shapeJsId, isActive)
   * @return {object} Returns the changes in state
   */
  shapeJsViewerIsActive: function shapeJsViewerIsActive(currentAttrs, action) {
    if (currentAttrs.isAvailable && currentAttrs.id === action.payload.shapeJsId) {
      return {
        isActive: action.payload.isActive
      };
    }
  },

  /**
   * @param {object} currentAttrs Current state.
   * @param {object} action Action type and payload(shapeJsId, materialAbbreviation, isFullColorMaterial, currentModelJson)
   */
  shapeJsMaterialSelected: function shapeJsMaterialSelected(currentAttrs, action) {
    if (currentAttrs.isAvailable && currentAttrs.id === action.payload.shapeJsId) {
      var modelUrl = action.payload.isFullColorMaterial ? action.payload.currentModelJson.baseUrlVisual : action.payload.currentModelJson.baseUrlAnalytical;
      this.updateShapejsParameters({model: modelUrl, material: action.payload.materialAbbreviation});
    }
  },

  /**
   * @param {object} currentAttrs Current state.
   * @param {object} action Action type and payload(shapeJsId)
   * @return {object} Returns the changes in state
   */
  shapeJsViewerStartPreventInteraction: function shapeJsViewerStartPreventInteraction(currentAttrs, action) {
    if (currentAttrs.isAvailable && currentAttrs.isStarted && currentAttrs.isActive && currentAttrs.id === action.payload.shapeJsId) {
      return {
        isPreventInteraction: true
      };
    }
  },

  /**
   * @param {object} currentAttrs Current state.
   * @param {object} action Action type and payload(shapeJsId)
   * @return {object} Returns the changes in state
   */
  shapeJsViewerStopPreventInteraction: function shapeJsViewerStopPreventInteraction(currentAttrs, action) {
    if (currentAttrs.isAvailable && currentAttrs.isStarted && currentAttrs.isActive && currentAttrs.id === action.payload.shapeJsId) {
      return {
        isPreventInteraction: false
      };
    }
  },

  /**
   * @param {object} currentAttrs Current state.
   * @param {object} action Action type and payload(shapeJsId, paramValues)
   */
  shapeJsViewerUpdateParams: function shapeJsViewerUpdateParams(currentAttrs, action) {
    if (currentAttrs.isAvailable && currentAttrs.id === action.payload.shapeJsId && action.payload.paramValues) {
      this.updateShapejsParameters(action.payload.paramValues);
    }
  }

});

module.exports = ShapeJsModel;
